

export default {
	namespaced: true,

	state: {
		screenPos: { x: 0, y: 65, z: -27 },
		labelPos: {x: 0, y: 20, z: -5},
		scorePos: {x: 75, y: 10, z: 70},
		// scoreRot: {x: 0, y: -Math.PI * .1, z: 0},
		mainColor: 0x21375f
	},

	getters: {
		screenPos(state) {
			return state.screenPos
		},
		scorePos(state) {
			return state.scorePos
		},
		scoreRot(state) {
			return state.scoreRot
		},
		labelPos(state) {
			return state.labelPos
		},
		mainColor(state) {
			return state.mainColor
		}
	},

	actions: {
		// showPrehome( { commit, state } ) {
		// 	commit('showPrehome');
		// }
	},

	mutations: {
		// loadingStart(state) {
		// 	state.isLoading = true;
		// }
	}
}